<template>
  <div>
    <LayoutSwipeList>
      <SwiperSlide v-for="(item, index) in items" :key="index">
        <ThemeTeaser :theme="item" />
      </SwiperSlide>
    </LayoutSwipeList>
  </div>
</template>

<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue'
const props = withDefaults(
  defineProps<{
    count?: number
    paperId?: number
  }>(),
  {
    count: 15,
  }
)
const nuxtApp = useNuxtApp()
const { data: items } = await useAsyncData(
  `themes-${props.count}-${props.paperId}`,
  async () => {
    return await nuxtApp.$api.content.mmThemes({
      paper: props.paperId,
      count: props.count,
      offset: 0,
    })
  }
)
</script>
